// eslint-disable-next-line import/prefer-default-export
export const PdpTabsLabels = {
  PLP: {
    plpTiles: {
      lbl_size_chart: 'Size Chart',
    },
  },
};
